import { isNull } from "lodash";
import Row from "../../../../components/Common/Row";
import Col from "../../../../components/Common/Col";
import React from "react";

interface IProps {
  title: string;
  value: boolean | null
}

const LicenceItem = (props: IProps) => {
  const { title, value } = props;

  if (isNull(value)) {
    return null;
  }

  return (
    <Row className="margin-bottom-xs">
      <Col>
        <strong>{title}:</strong> {value ? 'Yes' : 'No'}
      </Col>
    </Row>
  )
}

export default LicenceItem
